angular.module('zc.core')
  .directive('autoFillSync', autoFillSync);

autoFillSync.$inject = ['$interval'];
function autoFillSync($interval) {
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ngModel) {
      let origVal = elem.val();
      $interval(function() {
        let newVal = elem.val();
        if(ngModel.$pristine && origVal !== newVal) {
          ngModel.$setViewValue(newVal);
          origVal = newVal;
        }
      }, 500);
    }
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/auto_fill_sync.directive.js